<template>
  <ActivationModal
    v-show="activationPopup"
    :user-email="form.email"
    :verification-code="verificationCode"
    :user-password="password"
    :verification-is-wrong="verificationIsWrong"
    :sending-message="sendingMessage"
  />
  <LoginModal
    v-show="passwordPopup"
    :result-message="resultMessage"
    :password-is-wrong="passwordIsWrong"
    :user-email="form.email"
    :sending-message="sendingMessage"
  />

  <div
    v-show="$store.state.currentUrlX.indexOf(`contact`) == -1"
    class="container-fluid contact-form"
  >
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="contact-information">
            <h3>
              {{ $store.getters.getWordLocale('txt_iletisim') }}
            </h3>
            <strong>{{ toTitles($store.getters.getWordLocale('txt_yetkili_kisi')) }} </strong>
            <span>{{ contactPerson }}</span>

            <strong>{{ toTitles($store.getters.getWordLocale('txt_adres')) }} </strong>
            <span>{{ companyAddress }}</span>

            <strong>{{ toTitles($store.getters.getWordLocale('txt_telefon')) }} </strong>
            <span>{{ phone }}</span>
          </div>
        </div>

        <div class="col-12 col-md-8">
          <form class="contact-information-form">
            <div class="row">
              <div class="col-12 col-sm-6 mb-4">
                <input
                  v-model="form.nameSurname"
                  type="text"
                  :class="{
                    'form-control': true,
                    'red-border': v$.form.nameSurname.$errors.length > 0,
                    'green-border': userNameOut && v$.form.nameSurname.$errors.length == 0
                  }"
                  :placeholder="toTitles($store.getters.getWordLocale('txt_ad_soyad'))"
                  @focusout="validateNamesurname"
                />
                <div v-show="v$.form.nameSurname.$errors.length > 0" class="form-error">
                  {{ $store.getters.getWordLocale('txt_adinizi_giriniz') }}
                </div>
              </div>
              <div class="col mb-4">
                <input
                  v-model="form.email"
                  type="text"
                  :class="{
                    'form-control': true,
                    'red-border': v$.form.email.$errors.length > 0,
                    'green-border': emailOut && v$.form.email.$errors.length == 0
                  }"
                  :placeholder="toTitles($store.getters.getWordLocale('txt_eposta'))"
                  @focusout="validateEmail"
                />
                <div v-show="v$.form.email.$errors.length > 0" class="form-error">
                  {{ $store.getters.getWordLocale('txt_gecerli_eposta_adresi_giriniz') }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-12 mb-4">
                <input
                  v-model="form.companyName"
                  type="text"
                  :class="{
                    'form-control': true
                  }"
                  :placeholder="toTitles($store.getters.getWordLocale('txt_firma_adi'))"
                />
              </div>
            </div>

            <div class="mb-4">
              <select
                v-model="form.country"
                :class="{
                  'form-select form-control': true,
                  'red-border': form.country == '' && submitted,
                  'green-border': form.country != 0
                }"
                @change="setSelectedCountryId($event)"
              >
                <option
                  v-for="(country, ci) in countries"
                  :key="ci"
                  :value="country.code"
                  :class="{
                    disabled: country.id == 0,
                    selected: country.id == 0
                  }"
                >
                  {{ country.text }}
                </option>
              </select>
              <div v-show="form.country == 0 && submitted" class="form-error">
                {{ $store.getters.getWordLocale('txt_please_select_country') }}
              </div>
            </div>
            <!-- <div class="mb-4">
              <input
                maxlength="250"
                v-on:focusout="validateSubject"
                v-model="form.subject"
                :placeholder="
                  toTitles(this.$store.getters.getWordLocale('txt_konu'))
                "
                type="text"
                v-bind:class="{
                  'form-select form-control': true,
                  'red-border': v$.form.subject.$errors.length > 0,
                  'green-border':
                    subjectOut && v$.form.subject.$errors.length == 0,
                }"
                id=""
              />
              <div
                class="form-error"
                v-show="v$.form.subject.$errors.length > 0"
              >
                {{ this.$store.getters.getWordLocale("txt_konu_giriniz") }}
              </div>

              <div
                v-bind:class="{
                  'float-end': true,
                  'mb-3': true,
                  'footer-color': form.subject.length != 250,
                  'text-white': form.subject.length == 250,
                }"
              >
                {{ form.subject.length }}/250
              </div>
            </div> -->
            <div class="mb-3">
              <textarea
                v-model="form.message"
                minlength="6"
                maxlength="700"
                :class="{
                  'form-select form-control': true,
                  'red-border': v$.form.message.$errors.length > 0,
                  'green-border': messageOut && v$.form.message.$errors.length == 0
                }"
                :placeholder="toTitles($store.getters.getWordLocale('txt_mesaj'))"
                @focusout="validateMessage"
              ></textarea>
              <div v-show="v$.form.message.$errors.length > 0" class="form-error">
                {{ $store.getters.getWordLocale('txt_mesaj_giriniz') }}
              </div>
              <div
                :class="{
                  'float-end': true,
                  'mb-3': true,
                  'footer-color': form.message.length != 700,
                  'text-white': form.message.length == 700
                }"
              >
                {{ form.message.length }}/700
              </div>
            </div>
            <div class="d-flex justify-content-center justify-content-sm-between mt-4 w-100">
              <div class="footer-file-box">
                <!-- <a class="btn"
                  ><i class="material-icons-outlined">attach_file</i> Attach</a
                > -->
              </div>

              <a href="javascript:;" class="btn btn-online-primary" @click="submitForm">
                {{ toTitles($store.getters.getWordLocale('txt_mesaj_gonder')) }}
                <span v-show="sendingMessage"><i class="fa fa-spinner fa-spin"></i></span>
              </a>
            </div>
          </form>

          <div v-show="messageSent" class="alert mt-1 alert-success text-center">
            <i class="fa fa-info-circle"></i>
            {{ $store.getters.getWordLocale('txt_mesajiniz_basariyla_gonderildi') }}
          </div>

          <div v-show="errorSending" class="alert mt-1 alert-danger text-center">
            <i class="fa fa-info-circle"></i>
            {{ $store.getters.getWordLocale('txt_mesaj_gonderirken_hata_olustu') }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid footer-information-cf">
    <div class="container footer-information">
      <img v-if="$store.state.footerLogoV != ''" :src="$store.state.footerLogoV" />
      <img v-else :src="require(`/src/assets/img/Forie_Network.svg`)" />
      <p>
        © 1997-{{ new Date().getFullYear() }}
        <a :href="'https://turkishexporter.com.tr/' + $store.state.langCodeX + '/'"
          >TURKISHEXPORTER.COM.TR</a
        >
        | All Rights Reserved
      </p>
      <p>
        This website belongs to Turkishexporter which is the largest export portal of Turkey. Due to
        its membership
        <a
          :href="
            'https://www.turkishexporter.com.tr/' +
            $store.state.langCodeX +
            '/companies/' +
            $store.state.singleCompanyIdX
          "
          >{{ companyName }}</a
        >
        has been allocated.
      </p>
      <p>
        You can reach this member company from
        <a
          :href="
            'https://www.turkishexporter.com.tr/' +
            $store.state.langCodeX +
            '/companies/' +
            $store.state.singleCompanyIdX
          "
          >{{ companyName }}</a
        >
        contact page or call : {{ phone }}
      </p>
    </div>
  </div>
</template>

<script>
import useValidate from '@vuelidate/core'
import helper from '../theme3/helper'
import { required, email, minLength, maxLength } from '@vuelidate/validators'
import ActivationModal from '../shared/ContactModals/ActivationModal.vue'
import LoginModal from '../shared/ContactModals/LoginModal.vue'

export default {
  components: {
    ActivationModal,
    LoginModal
  },
  data() {
    return {
      passwordIsWrong: false,
      resultMessage: 'OpenPasswordModal',
      verificationIsWrong: false,
      verificationCode: '',
      messageOut: false,
      subjectOut: false,
      emailOut: false,
      userNameOut: false,
      companyName: '',
      errorSending: false,
      messageSent: false,
      sendingMessage: false,
      submitted: false,
      v$: useValidate(),
      form: {
        nameSurname: '',
        companyName: '',
        email: '',
        country: '',
        subject: '',
        message: ''
      },
      countries: [],
      companyAddress: '',
      contactPerson: '',
      phone: ''
    }
  },
  watch: {
    $route() {
      this.clearSendingMessageForm()
    }
  },
  validations() {
    return {
      form: {
        nameSurname: { required },
        email: { required, email },
        country: { required },
        // subject: { required, min: minLength(5), max: maxLength(250) },
        message: { required, min: minLength(6), max: maxLength(700) }
      }
    }
  },
  mounted() {
    console.log(this.$store.state.singleCompanyDetailsX)
    this.companyName =
      this.$store.state.singleCompanyDetailsX.Localizations.filter(
        (q) => q.LangCode == this.$store.state.langCodeX
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].Name
        : this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].Name

    if (this.$store.state.fullCountriesX.length == 0) {
      this.getCountries()
    } else {
      this.buildCountriesInfo(this.$store.state.fullCountriesX)
    }

    if (this.$store.state.singleCompanyFullInfoX.length == 0) {
      this.getCompanyInformation()
    } else {
      this.buildCompanyInfo(this.$store.state.singleCompanyFullInfoX)
    }
  },
  methods: {
    setSelectedCountryId(e) {
      this.form.country = e.target.value
      this.validateCountry()
    },
    validateNamesurname() {
      this.userNameOut = true
      this.v$.form.nameSurname.$validate()
    },
    validateCountry() {
      return !(this.form.country == '')
    },
    validateEmail() {
      this.emailOut = true
      this.v$.form.email.$validate()
    },
    validateSubject() {
      this.subjectOut = true
      this.v$.form.subject.$validate()
    },
    validateMessage() {
      this.messageOut = true
      this.v$.form.message.$validate()
    },
    submitForm() {
      this.messageSent = false
      this.errorSending = false

      this.submitted = true
      this.v$.$validate() // checks all inputs
      if (!this.v$.$error) {
        this.sendMessage()
      }
    },
    async sendMessage(password, verificationCode) {
      this.passwordIsWrong = false
      this.verificationIsWrong = false
      var encryptedPassword = this.$store.state.userPasswordX
      if (password == undefined) {
        password = ''
      }

      if (
        encryptedPassword != '' &&
        encryptedPassword != undefined &&
        encryptedPassword != null &&
        this.password == ''
      ) {
        password = encryptedPassword
      }

      this.password = password

      if (verificationCode == undefined) {
        verificationCode = ''
      }
      if (this.sendingMessage) {
        return 0
      }

      this.sendingMessage = true

      this.messageSent = false
      this.errorSending = false

      var result = []

      this.form.nameSurname = helper.clearHtml(this.form.nameSurname)
      this.form.subject = helper.clearHtml(this.form.subject)
      this.form.message = helper.clearHtml(this.form.message)
      this.form.companyName = helper.clearHtml(this.form.companyName)

      var isEncryptedPassword = ''
      if (this.$store.state.userLoggedInX) {
        isEncryptedPassword = 'true'
      }

      var selectedCommPlatforms = ''
      await fetch(
        `${this.$store.state.apiUrlX}/api/v2/chat/SendMessageToChat/?name=${
          this.form.nameSurname
        }&languageCode=${this.$store.state.langCodeX}&subject=${this.form.subject}&message=${
          this.form.message
        }&country=${this.form.country}&email=${this.form.email}&companyName=${
          this.form.companyName
        }&isEncryptedPassword=${isEncryptedPassword}&password=${password}&activationCode=${verificationCode}&fax=&phone=&webSite=&address=&communicationPlatformIds=${selectedCommPlatforms}&targetCompanySecondaryIds=${parseInt(
          this.$store.state.singleCompanyIdX
        )}`,
        {
          method: 'post',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Public-WebAccessToken': this.$store.state.publicAccessTokenX,
            companyId: 0
          },
          body: JSON.stringify({})
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message))

      if (result.result == 'warning') {
        this.resultMessage = result.message

        if (result.message == 'OpenPasswordModal' || result.message == 'AskForPassword') {
          this.passwordPopup = true
        } else if (result.message == 'PasswordIsWrong') {
          this.passwordIsWrong = true
        } else if (result.message == 'SendActivationCode') {
          this.passwordPopup = false
          this.activationPopup = true
        } else if (result.message == 'ActivationCodeIsWrong') {
          this.verificationIsWrong = true
        }
      } else {
        this.passwordPopup = false
        this.activationPopup = false
        this.clearSendingMessageForm()
        this.messageSent = true
      }

      this.sendingMessage = false
      // if (result.result == "Success") {
      //   this.messageSent = true;
      //   this.clearSendingMessageForm();
      // } else {
      //   //this.errorSending = true;
      // }
    },
    closeLoginModal() {
      this.sendingMessage = false
      this.passwordPopup = false
    },
    closeActivationModal() {
      this.sendingMessage = false
      this.activationPopup = false
    },
    clearSendingMessageForm() {
      this.form.nameSurname = ''
      this.form.companyName = ''
      this.form.email = ''
      this.form.country = ''
      this.form.subject = ''
      this.form.message = ''
      this.submitted = false

      this.userNameOut = false
      this.emailOut = false
      this.form.country = ''
      this.subjectOut = false
      this.messageOut = false

      this.messageSent = false
      this.errorSending = false

      this.v$.$reset()
    },
    async getCountries() {
      var tempList = []

      await fetch(`https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCountries`, {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
      })
        .then((res) => res.json())
        .then((data) => (tempList = data))
        .catch((err) => console.log(err.message))

      this.$store.state.fullCountriesX = tempList
      this.buildCountriesInfo(this.$store.state.fullCountriesX)
    },
    buildCountriesInfo(vatiable) {
      vatiable.forEach((element) => {
        var name =
          element.Localizations.filter((q) => q.LangCode == this.$store.state.langCodeX).length > 0
            ? element.Localizations.filter((q) => q.LangCode == this.$store.state.langCodeX)[0].Name
            : element.Localizations.filter((q) => q.LangCode != this.$store.state.langCodeX)
                  .length > 0
              ? element.Localizations.filter((q) => q.LangCode != this.$store.state.langCodeX)[0]
                  .Name
              : element.TagName

        this.countries.push({
          text: name,
          code: element.CountryCode,
          id: parseInt(element._id),
          flag: element.Flag
        })
      })

      this.countries.unshift({
        text: this.$store.getters.getWordLocale('txt_ulke_sec'),
        code: '',
        id: 0,
        flag: ''
      })
    },
    toTitles(s) {
      return s.replace(/\w\S*/g, function (t) {
        return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase()
      })
    },
    async getCompanyInformation() {
      var result = []
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanyInformation`,
        {
          method: 'post',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            companyId: this.$store.state.singleCompanyIdX
          })
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message))

      this.$store.state.singleCompanyFullInfoX = result

      this.buildCompanyInfo(result)
    },
    buildCompanyInfo(variable) {
      this.membershipName =
        variable.CompanyActiveMembership.Localizations.length == 0
          ? ''
          : variable.CompanyActiveMembership.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              ).length > 0
            ? variable.CompanyActiveMembership.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : variable.CompanyActiveMembership.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name

      this.memebrshipIcon = variable.CompanyActiveMembership.Icon

      variable.CompanyContactInformations.forEach((element) => {
        var address = element.Address
        if (this.companyAddress == '') {
          this.companyAddress = address
        }
        if (this.contactPerson == '') {
          this.contactPerson = element.ContactPearson
        }

        element.Phones.forEach((tel) => {
          if (this.phone == '') {
            this.phone = tel
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.form-error {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.footer-color {
  color: #d9e3f8 !important;
}

.red-border {
  border-color: #e1000f !important;
}

.green-border {
  border-color: #99c99b !important;
}

.contact-information-form .form-select.form-control {
  text-transform: capitalize;
}

@import './style.css';
</style>
